//region :: Imports ::
import {IMsalContext} from '@azure/msal-react';
import AccessTokenProvider from '../Toolkit/Api/AccessTokenProvider';

//endregion;

/** */
class SafeDigAccessTokenProvider extends AccessTokenProvider {

    /** */
    public constructor(msalContext: IMsalContext) {
        super(msalContext, ['api://85917eef-4f01-44bd-8506-902d603888ed/user_impersonation']);

    }

}

export default SafeDigAccessTokenProvider;